import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { VoucherStatusUpdateFormSchemas } from 'schemas/vouchersSchemas'
import { UpdateVouchersStatusFormTypes } from 'types/vouchers'

export const useMemberVouchersStatusUpdateForm = ({
  defaultValues,
}: {
  defaultValues: UpdateVouchersStatusFormTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<UpdateVouchersStatusFormTypes>({
    resolver: zodResolver(VoucherStatusUpdateFormSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
